import api from "!../../../../iot-devtool/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../iot-devtool/node_modules/css-loader/dist/cjs.js!./layout.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};